export default __webpack_public_path__ + "static/media/de02.fdc2d3d5.jpg";